import React from 'react'
import ParagraphTag from "../reusebale/Paragraph"
import {MessageCircleMore} from "lucide-react"

const NoChat = () => {
    return (
        <div className='flex flex-col items-center w-full justify-center mt-10'>
            {/* <ImageTag path='/assets/daashboard/nodata.png' classes='w-[50px]' altText='login' /> */}
            <MessageCircleMore color='#0381CA' size={70}/>
            <ParagraphTag content='No Chat Found' classes='text-darkColor text-base pt-2 font-popinsRegular' />
        </div>
    )
}

export default NoChat